import React from "react";
import toast from "react-hot-toast";

const TYPE_CONFIG = {
  success: {
    color: "#16a34a",
    cardBg: "#f0fdf4",
    border: "#bbf7d0",
    barBg: "#dcfce7",
    textColor: "#15803d",
    icon: "✓",
  },
  error: {
    color: "#dc2626",
    cardBg: "#fef2f2",
    border: "#fecaca",
    barBg: "#fee2e2",
    textColor: "#991b1b",
    icon: "✕",
  },
  warning: {
    color: "#d97706",
    cardBg: "#fffbeb",
    border: "#fde68a",
    barBg: "#fef3c7",
    textColor: "#92400e",
    icon: "!",
  },
  info: {
    color: "#2563eb",
    cardBg: "#eff6ff",
    border: "#bfdbfe",
    barBg: "#dbeafe",
    textColor: "#1e40af",
    icon: "i",
  },
};

const ClassicToast = ({ t, type = "info", message, duration = 3000 }) => {
  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.info;

  return (
    <div
      style={{
        minWidth: 260,
        maxWidth: 360,
        background: cfg.cardBg,
        border: `1px solid ${cfg.border}`,
        borderLeft: `4px solid ${cfg.color}`,
        borderRadius: 8,
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.04)",
        overflow: "hidden",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        opacity: t.visible ? 1 : 0,
        transform: t.visible ? "translateX(0)" : "translateX(20px)",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        pointerEvents: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 10,
          padding: "9px 12px",
        }}
      >
        <div
          aria-hidden
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            background: cfg.color,
            color: "#ffffff",
            display: "grid",
            placeItems: "center",
            fontSize: 11,
            fontWeight: 800,
            flexShrink: 0,
            marginTop: 1,
            lineHeight: 1,
          }}
        >
          {cfg.icon}
        </div>
        <div
          style={{
            flex: 1,
            fontSize: 12.5,
            fontWeight: 500,
            color: cfg.textColor,
            lineHeight: 1.4,
            paddingTop: 1,
            wordBreak: "break-word",
          }}
        >
          {message}
        </div>
        <button
          type="button"
          onClick={() => toast.dismiss(t.id)}
          aria-label="Close notification"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            width: 18,
            height: 18,
            color: cfg.textColor,
            opacity: 0.6,
            fontSize: 16,
            lineHeight: 1,
            display: "grid",
            placeItems: "center",
            flexShrink: 0,
            borderRadius: 4,
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.6)}
        >
          ×
        </button>
      </div>
      <div
        style={{
          height: 2.5,
          background: cfg.barBg,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            background: cfg.color,
            transformOrigin: "left center",
            animation: `classicToastShrink ${duration}ms linear forwards`,
          }}
        />
      </div>
      <style>{`
        @keyframes classicToastShrink {
          from { transform: scaleX(1); }
          to   { transform: scaleX(0); }
        }
      `}</style>
    </div>
  );
};

export const showToast = (type, message, duration = 3000) =>
  toast.custom(
    (t) => (
      <ClassicToast t={t} type={type} message={message} duration={duration} />
    ),
    { duration },
  );

showToast.success = (message, duration = 3000) => showToast("success", message, duration);
showToast.error = (message, duration = 3000) => showToast("error", message, duration);
showToast.warning = (message, duration = 3000) => showToast("warning", message, duration);
showToast.info = (message, duration = 3000) => showToast("info", message, duration);

export default ClassicToast;
